export default "__VITE_ASSET__CpsTgcyc__"